/* eslint-disable eqeqeq */
import { globalColors } from "../../../../../../_metronic/_assets/sass/custom/globalColors.js";

export function getLabelAndColorEmail(note) {
  const status = {
    "EMAIL DIFERIDO": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "EMAIL ENTREGUE": {
      label: "EMAIL ENTREGUE",
      color: globalColors.successColor,
      textColor: globalColors.textColor2,
    },
    "EMAIL PROCESSADO": {
      label: "ENVIANDO EMAIL",
      color: globalColors.alertColorLight,
      textColor: globalColors.textColor2,
    },
    "EMAIL ENVIADO": {
      label: "EMAIL ENVIADO",
      color: globalColors.warningColor,
      textColor: globalColors.textColor2,
    },

    "EMAIL DESCARTADO": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "EMAIL DESCONHECIDO": {
      label: note?.toUpperCase(),
      color: "#808080",
      textColor: "#FFFFFF",
    },
    "EMAIL REJEITADO": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "AÇÃO REALIZADA COM SUCESSO": {
      label: "AÇÃO REALIZADA COM SUCESSO",
      color: globalColors.successColor,
      textColor: globalColors.textColor2,
    },
    "EMAIL DEBOUNCE": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "EMAIL SPAM_REPORT": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "EMAIL UNSUBSCRIBE": {
      label: "EMAIL NÃO ENTREGUE",
      color: globalColors.alertColor2,
      textColor: globalColors.textColor2,
    },
    "EMAIL ABERTO": {
      label: "EMAIL ABERTO",
      color: "#ADD8E6",
      textColor: globalColors.textColor2,
    },
    "EMAIL CLICADO": {
      label: "EMAIL CLICADO",
      color: "#ADD8E6",
      textColor: globalColors.textColor2,
    },
  };

  if (!note) return "";

  const upperCaseNote = note.toUpperCase();
  return status[upperCaseNote.trim()] || status["EMAIL DESCONHECIDO"];
}
